import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import queryString from 'query-string';
import { userResetPasswordAction } from 'store/actions/login';
import FormInput from 'components/common/Input';
import LoginButton from 'components/common/Button';
import ErrorMessage from 'components/common/ErrorMessage';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const SetNewPassword = ({ location }) => {
  const [newPw, setNewPw] = useState('');
  const [reNewPw, setReNewPw] = useState('');
  const [isMinChar, setIsMinChar] = useState(false);
  const dispatch = useDispatch();
  const queries = queryString.parse(location.search);
  const requestStatus = useSelector((state) => state.status);

  const handleSubmit = () => {
    const token = queries.token || null;
    dispatch(
      userResetPasswordAction({
        resetToken: token,
        password: newPw,
        passwordConfirmation: reNewPw,
      }),
    );
  };

  const meetsMinCharCount = (pw, field) => {
    switch (field) {
      case 'newPw':
        setIsMinChar(pw.length >= 8 && reNewPw.length >= 8);
        break;
      default:
        setIsMinChar(newPw.length >= 8 && pw.length >= 8);
    }
  };

  const handlePasswordOneChange = (e) => {
    setNewPw(e.target.value);
    meetsMinCharCount(e.target.value, 'newPw');
  };

  const handlePaswordTwoChange = (e) => {
    setReNewPw(e.target.value);
    meetsMinCharCount(e.target.value, 'reNewPw');
  };

  const newpw = 'Please select a new password';

  return (
    <SetNewPassword.NewPwContainer>
      <SetNewPassword.NewPwTitle>
        {newpw}
        <FormInput
          onChange={handlePasswordOneChange}
          placeholder="New Password"
          type="password"
          hasValue={newPw && newPw.length > 0}
          hasError={requestStatus.hasError}
          zIndex="1"
          errorColor="#D6FE36"
        />
        <FormInput
          onChange={handlePaswordTwoChange}
          placeholder="Re-Type Password"
          type="password"
          hasValue={reNewPw && reNewPw.length > 0}
          hasError={requestStatus.hasError}
          errorColor="#D6FE36"
        />
        {requestStatus.hasError && requestStatus.errorMessage && (
          <ErrorMessage errorColor="#D6FE36" message={requestStatus.errorMessage} />
        )}
        <SetNewPassword.ValidationContainer isMinChar={isMinChar}>
          <SetNewPassword.ValidationCheckMark
            src={
              isMinChar
                ? '/assets/images/icn-checkbox-selected-light.png'
                : '/assets/images/icn-checkbox-selected-dark.png'
            }
          />
          <SetNewPassword.ValidationText>
            Must be at least 8 characters
          </SetNewPassword.ValidationText>
        </SetNewPassword.ValidationContainer>
        <LoginButton onSubmit={handleSubmit} text="SUBMIT" />
      </SetNewPassword.NewPwTitle>
      {requestStatus.redirect && <Redirect to="/login" />}
      <SetNewPassword.Alias>ALIAS BY GOAT GROUP</SetNewPassword.Alias>
    </SetNewPassword.NewPwContainer>
  );
};

SetNewPassword.NewPwContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 394px;
  width: 290px;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;
SetNewPassword.NewPwTitle = styled.h1`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  font-family: ${FONTS.default};
  width: 289px;
  color: ${COLORS.primaryText};
`;

SetNewPassword.Alias = styled.div`
  font-size: 12px;
  letter-spacing: 3px;
  color: ${COLORS.secondaryText};
  position: absolute;
  bottom: 33px;
`;

SetNewPassword.ValidationCheckMark = styled.img`
  margin: 2px 8px 0px 0px;
`;

SetNewPassword.ValidationText = styled.span`
  padding-top: 5px;
  font-family: ${FONTS.default};
`;

SetNewPassword.ValidationContainer = styled.div`
  height: 16px;
  font-size: 14px;
  line-height: 20px;
  margin-top: 16px;
  letter-spacing: 0.25px;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: ${(props) => (props.isMinChar ? COLORS.primaryText : COLORS.secondaryText)};
`;

SetNewPassword.propTypes = {
  location: PropTypes.shape({ search: PropTypes.string }),
};

export default SetNewPassword;
